import { render } from "./ResourceImage.vue?vue&type=template&id=2457a704"
import script from "./ResourceImage.vue?vue&type=script&lang=js"
export * from "./ResourceImage.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__